const testIdAttribute = 'data-test-id';
export const NnTestIds = {
  RedPriceElement: 'price-red-color',
  CurrentPriceElement: 'price-current',
  ComparePriceElement: 'price-compare',
  OriginalPricePrefixSuffix: 'price-original-prefix-suffix',
  CheckoutProductRecommendationSection: 'checkout-product-recommendation-section',
  CheckoutVoucherSubmitButton: 'checkout-voucher-submit-button',
  CheckoutVoucherSubmitButtonFulfilled: 'checkout-voucher-submit-button-fulfilled',
  CheckoutVoucherSubmitButtonRejected: 'checkout-voucher-submit-button-rejected',
  CheckoutSubTotal: 'checkout-sub-total',
  CheckoutDiscountTotal: 'checkout-discount-total',
  CheckoutTogglePartialDelivery: 'checkout-toggle-partial-delivery',
  CheckoutPartialDeliveryCheckbox: 'checkout-partial-delivery-checkbox',
  CheckoutErrorBanner: 'checkout-error-banner',
  DiscountBadge: 'price-type-badge',
  InputNumberField: 'input-number-field',
  ProductCardAddToCart: 'product-card-add-to-cart',
  ProductCardAddToWishlist: 'product-card-add-to-wishlist',
  ProductQuantityIncrease: 'product-quantity-increase',
  ProductQuantityDecrease: 'product-quantity-decrease',
  HeaderCartIcon: 'header-cart-icon',
  HeaderCartIconCount: 'header-cart-icon-count',
  MenuLevelHeading: 'menu-level-heading',
  MiniCartCloseButton: 'mini-cart-close-button',
  MyPagesButton: 'my-pages-button',
  MyPagesLoginForm: 'my-pages-login-form',
  MyPagesStartPage: 'my-pages-start-page',
  MyPagesStartPageOrderHistoryLink: 'my-pages-start-page-order-history-link',
  MyPagesStartPageWishlistLink: 'my-pages-start-page-wishlist-link',
  MyPagesMenu: 'my-pages-menu',
  MyPagesLogoutButton: 'my-pages-logout-button',
  OrderHistoryPage: 'order-history-page',
  OrderHistoryDetailsLink: 'order-history-details-link',
  OrderHistoryDetailsPage: 'order-history-details-page',
  OrderHistoryDetailsPdfLink: 'order-history-details-pdf-link',
  OrderConfirmationContainer: 'order-confirmation-container',
  StockStatusInStock: 'stock-status-in-stock',
  AuthFlyoutHeader: 'auth-flyout-header',
  MobileMenuMyPagesButton: 'mobile-menu-my-pages-button',
  StringConfiguratorPdpButton: 'string-configurator-pdp-button',
  ProductConfigurationIframe: 'product-configuration-iframe',
  ProductConfigurationAddToCartButton: 'product-configuration-add-to-cart-button',
  HeaderSearchBtn: 'header-search-btn',
  QuickSearchBtn: 'quick-search-btn',
  QuickSearchInput: 'quick-search-input',
  CreateNewAccountForm: 'create-new-account-form',
  ProductVariationSelector: 'product-variation-selector',
  ProductVariationMobileOptionContainer: 'product-variation-mobile-option-container',
  AddToCartButtonPDP: 'add-to-cart-button-pdp',
  MyWishListElement: 'my-wishlist-element',
  MyWishListElementRemove: 'my-wishlist-element-remove',
  HeaderMyWishlinkIconCount: 'header-my-wishlist-icon-count',
  AddToWishListButton: 'add-to-wishlist-button',
  RemoveFromWishListButton: 'remove-from-wishlist-button',
  PlpProductCount: 'plp-product-count',
  PlpFilterButton: 'plp-filter-button',
  PlpSortButton: 'plp-sort-button',
  PlpSortOptionRelevance: 'plp-sort-option-relevance',
  PlpSortOptionPrice: 'plp-sort-option-price',
  PlpSortOptionPriceDesc: 'plp-sort-option-price-desc',
  PlpSortOptionNew: 'plp-sort-option-new',
  PlpSortOptionDiscount: 'plp-sort-option-discount',
  BooleanFacet: 'boolean-facet',
  RangeFacet: 'range-facet',
  FacetHeader: 'facet-header',
  FacetHeaderExpandableButton: 'facet-header-expandable-button',
  FacetHeaderExpandableAllItems: 'facet-header-expandable-all-items',
  FacetHeaderExpandableItem: 'facet-header-expandable-item',
  FacetHeaderItem: 'facet-header-item',
  FacetHeaderItemCount: 'facet-header-item-count',
  FilterFlyoutConfirmButton: 'filter-flyout-confirm-button',
  FilterFlyoutResetButton: 'filter-flyout-reset-button',
  FilterFlyoutBackButton: 'filter-flyout-back-button',
  ProductListingPaginationNextButton: 'plp-pagination-next-button',
  PlpPaginationShowMoreButton: 'plp-pagination-show-more-button',
  PdpDiscountInfo: 'pdp-discount-info',
  PdpPriceInfoIcon: 'pdp-price-info-icon',
  PdpOriginalPriceElement: 'pdp-price-original',
  BreadCrumbLink: 'breadcrumb-link',
};
type NnTestIdsType = typeof NnTestIds;

export const NnTestIdProps: {
  [P in keyof NnTestIdsType]: ReturnType<typeof testId>;
} = {} as any;
for (const key of Object.keys(NnTestIds)) {
  (NnTestIdProps as any)[key] = testId(key as keyof NnTestIdsType);
}

export function testId(id: keyof NnTestIdsType) {
  return { [testIdAttribute]: NnTestIds[id] };
}

export const testValueAttribute = 'data-test-value';
export function NNTestValueProp(value?: string) {
  if (!value) {
    return {};
  }
  return { [testValueAttribute]: value };
}

export function getSortOptionTestIdProps(option: NordicNest.Api.SelectOptionApiModel) {
  switch (option.value) {
    case 'relevance':
      return NnTestIdProps.PlpSortOptionRelevance;
    case 'price':
      return NnTestIdProps.PlpSortOptionPrice;
    case 'priceDesc':
      return NnTestIdProps.PlpSortOptionPriceDesc;
    case 'new':
      return NnTestIdProps.PlpSortOptionNew;
    case 'discount':
      return NnTestIdProps.PlpSortOptionDiscount;
    default:
      return NnTestIdProps.PlpSortOptionRelevance;
  }
}
